import { render, staticRenderFns } from "./DirectLoginPage.vue?vue&type=template&id=ef6ccbb2&"
import script from "./DirectLoginPage.vue?vue&type=script&lang=js&"
export * from "./DirectLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports